import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { AppBar, Container, Toolbar, Typography } from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { useState, useContext } from "react";
import "./AdminPreferences.css";
import CombineYearSetup from "./CombineYearSetup";
import MaxVotingSetup from "./MaxVotingSetup";
import VotingTimelineSetup from "./VotingTimelineSetup";
import { AppDataContext } from "../../common/appContext";

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: "0.9rem",
    paddingTop: "2px",
  },
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  title: {
    flexGrow: 1,
  },
}));

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem", color: "#fff" }} />
    }
    {...props}
  />
))(({ theme }) => ({
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function AdminPreferences() {
  const classes = useStyles();
  const [expanded, setExpanded] = useState("panel2");
  const { user } = useContext(AppDataContext);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      <AppBar position="static" className={classes.appbarBackground}>
        <Toolbar>
          <Typography variant="h6" className={`${classes.title} header-title`}>
            Admin Preferences
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth={false}>
        {/* <div className="accordion-style">
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
          >
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
              className="accordion-header"
            >
              <Typography noWrap component="div" variant="subtitle2">
                Setup Current Combine Year
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <CombineYearSetup classes={classes} />
            </AccordionDetails>
          </Accordion>
        </div> */}
        <div className="accordion-style">
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
          >
            <AccordionSummary
              aria-controls="panel2d-content"
              id="panel2d-header"
              className="accordion-header"
            >
              <Typography noWrap component="div" variant="subtitle2">
                Configure Max Votes
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <MaxVotingSetup classes={classes} user={user} />
            </AccordionDetails>
          </Accordion>
        </div>
        <div className="accordion-style">
          <Accordion
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              className="accordion-header"
            >
              <Typography component="div" variant="subtitle2">
                Timeline To Enable/Disable Voting Feature For Teams
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <VotingTimelineSetup classes={classes} user={user} />
            </AccordionDetails>
          </Accordion>
        </div>
      </Container>
    </>
  );
}
